import {
  FilterDto,
  HospitalizationDto,
  HospitalizationFollowUpCountsDto,
  PaginatedResponse,
  CurrentAndPendingHospitalizationsDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';
import type { HospitalizationUpdateRequest } from '@act/shared/types';

export const hospitalizationsRequests = {
  getHospitalizations: EndpointDefinition.get<
    PaginatedResponse<HospitalizationDto>,
    {
      clientIds?: number[];
      guideIds?: string[];
      statusIds?: number[];
      'page-start'?: number;
      'page-size'?: number;
      'sort-by'?: string;
      'sort-direction'?: string;
      'special-filter'?: 'not-attempted' | 'not-offered';
      'behavioral-health-filter'?: boolean;
    }
  >({
    name: 'getHospitalizations',
    route: '/hospitalizations',
  }),
  getMetaCounts: EndpointDefinition.get<HospitalizationFollowUpCountsDto, null>(
    {
      name: 'getMetaCounts',
      route: '/hospitalizations/meta-counts',
    }
  ),
  getFilterOptions: EndpointDefinition.get<FilterDto[], null>({
    name: 'getFilterOptions',
    route: '/hospitalizations/filter-options',
  }),
  getCurrentAndPendingHospitalizations: EndpointDefinition.get<
    CurrentAndPendingHospitalizationsDto,
    { guideIds?: string[]; clientIds?: number[] }
  >({
    name: 'getCurrentAndPendingHospitalizations',
    route: '/hospitalizations/current-and-pending',
  }),
  updateHospitalization: EndpointDefinition.patch<
    HospitalizationDto,
    HospitalizationUpdateRequest,
    { id: number }
  >({
    name: 'updateHospitalization',
    route: '/hospitalizations/:id',
  }),
};
